import '../themes/default/borderRadius/index.js';
import '../themes/default/borderWidth/index.js';
import '../themes/default/color/index.js';
import '../themes/default/shape/index.js';
import '../themes/default/size/index.js';
import { SpacingAll } from '../themes/default/spacing/index.js';
import '../theming/themes/caviar.js';
import '../theming/themes/merchant.js';
import '../theming/themes/merchant-next.js';
import '../theming/themes/internal-tools.js';
import '../theming/icons/constants.js';
import '../theming/logo/constants.js';
import '../theming/typography/constants.js';
import 'lodash.clonedeep';
import 'lodash.merge';
import 'react';
import { css } from 'styled-components';

var BASE_STYLES = css(["max-width:100%;"]);
var BASE_SPACING = SpacingAll.Small; // To-Do: Look at converting these to enums in v8

var Justification = {
  Center: 'center',
  FlexStart: 'flex-start',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around'
};
var Alignment = {
  Center: 'center',
  FlexStart: 'flex-start',
  FlexEnd: 'flex-end',
  Baseline: 'baseline',
  Stretch: 'stretch'
};
var Direction = {
  LTR: 'LTR',
  RTL: 'RTL'
};

export { Alignment, BASE_SPACING, BASE_STYLES, Direction, Justification };
